export const SetupPaymentType = {
  Consultant: "Consultant",
  Client: "Client",
  SinglePayment: "SinglePayment",
} as const
